<div class="table-filter d-flex flex-column spacing-12">
  <div class="filter-section dropdown">
    <div
      app-search
      [active]="false"
      class="w-100"
      [SearchBtn]="false"
      [disabled]="false"
      (onSearch)="onActionClick({ action: 'filter_search', value: $event })"
      size="large"></div>
    <app-secondary-btns
      [active]="false"
      [disabled]="false"
      label="Filters"
      size="medium"
      IconValue=""
      IconType="convert"
      Type="leftIcon"
      class="position-relative"
      data-bs-toggle="dropdown"
      data-bs-auto-close="outside"
      aria-expanded="false">
    </app-secondary-btns>
    <!-- <app-filters
      class="dropdown-menu filter-drop dropdown-menu-end"
      [search]="showSearch"
      (onSelectFilter)="onActionClick({ action: 'filter_add_tag', value: $event })"
      (onClearAll)="onActionClick({ action: 'filter_clear_all' })"
      (custom_click)="onActionClick($event)"
      [filter_group_data]="filter_group_data"
      [dropdown]="dropdown"
      [attribute]="attribute"
      [label]="'filters'"
      [tabContent]="tabContent"
      [type]="'filter'"
      [active_info]="active_info"></app-filters> -->
  </div>
  <div class="filters-tags d-flex align-items-start">
    <ul class="filters p-0 m-0 flex-grow-1">
      @for (filter of filters; track filter) {
        <li>
          <app-filter-tag
            [alert]="!filter.filterValue"
            [tag]="filter"
            class="position-relative tag-dropdown"
            (custom_click)="onActionClick($event)">
            <app-filter-condition
              class="w-100 dropdown-menu-end"
              [filter]="filter"
              (customClick)="onActionClick($event, filter)"></app-filter-condition>

            <!-- @if (filter.type == 'price') {
          <app-price-filter
            cdkMenu
            [filter]="filter"
            (customClick)="onActionClick($event, filter)"
            class="price-dropdowns"
          ></app-price-filter>
          } @if (filter.type == 'number') {
          <app-qty-filter
            [filter]="filter"
            (customClick)="onActionClick($event, filter)"
            class="price-dropdowns w-100 dropdown-menu-end"
          ></app-qty-filter>
          } @if (filter.type == 'string' || filter.type == 'text') {
          <app-single-filter
            class="w-100 dropdown-menu-end"
            [stringComparisonFilter]="stringFilters"
            [filter]="filter"
            [filterType]="'default'"
            (customClick)="onActionClick($event, filter)"
          ></app-single-filter>
          } @if (filter.type == 'date') {
          <app-calendar
            [type]="'date_range'"
            [label]="''"
            [inline]="true"
            [filter]="filter"
            (customClick)="onActionClick($event, filter)"
            class="price-dropdown w-100 dropdown-menu-lg-end"
          ></app-calendar>
          } -->
          </app-filter-tag>
        </li>
      }
    </ul>
    @if ((filters.length || 0) > 0) {
      <app-link-btn
        class="text-nowrap"
        label="Clear all"
        [active]="false"
        size="medium"
        IconType="none"
        [disabled]="false"
        (custom_click)="onActionClick({ action: 'filter_clear_all' })"></app-link-btn>
    }
  </div>
</div>
